// import i18n from 'i18next';
// import en from './en.json';
// import { initReactI18next } from 'react-i18next';

// i18n
//   .use(initReactI18next)
//   .init({
//     fallbackLng: 'en',
//     resources: {
//       en: {
//         translation: en,
//       },
//     },
//     interpolation: {
//       escapeValue: false, // not needed for react as it escapes by default
//     },
//   })
//   .catch(console.warn);

// export default i18n;


/** to support MFE **/

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';


const browserLanguage = navigator.language || navigator.languages[0] || 'en-US';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    lng: browserLanguage,
    backend: {
      loadPath: '/locales/{{lng}}/dataSecurity.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

/*i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});*/

export default i18n;